import { render, staticRenderFns } from "./BulletListButton.vue?vue&type=template&id=52b0dfba&"
import script from "./BulletListButton.vue?vue&type=script&lang=js&"
export * from "./BulletListButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports